import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "px-2 text-theme-gray-700"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  props: {
    items: null,
    className: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.className)
  }, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `breadcrumb${index}`,
          class: _normalizeClass(["inline-block font-opensans text-xs", `${ index != __props.items.length - 1 ? 'text-theme-gray-700' : 'text-theme-black-700' }`])
        }, [
          (item.link)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: item.link }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.label), 1)),
          (index != __props.items.length - 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " > "))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ])
  ], 2))
}
}

})